import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import config from 'config';


const CONTENT_MAX_WIDTH = 1176;
const BASE_BG = `${config.imagesRoot}madad/noise-300.png`;




export const Root = styled.div``;

export const ContentBox = styled.div`
  margin: 0 auto;
  position: relative;
  max-width: ${CONTENT_MAX_WIDTH}px;
  width: 100%;
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    padding: 0 ${theme.spacing(2)};
  `}
`;

export const BannerSection = styled.section<{ isMobile: boolean }>`
  ${({ isMobile }) => `
    display: flex;
    overflow: hidden;
    position: relative;
    z-index: 1;
    ${isMobile ? 'min-height: 516px;' : 'min-height: 568px;'}
  `}
`;

export const BannerContent = styled.section<{isMobile: boolean, defaultDesktopBg?: string }>`
  ${({ isMobile, defaultDesktopBg, theme }) => `
      display: block;
      content: '';
      position: absolute;
      z-index: -1;
      bottom: 0;
      top: 0;
      left: -10%;
      right: -10%;
      padding: 0 10%;
      overflow: hidden;
      display: flex;

      ::before {
        content: ' ';
        background: no-repeat url(${defaultDesktopBg});
        ${isMobile ? `background: repeat ${theme.colors.brand.madlanGreen};` : ``}
        position: absolute;
        left: 0px;
        right: 0;
        bottom: 0;
        top: 0;
        display: block;
        background-position: center bottom;
      }
      border-bottom-left-radius: 100% ${isMobile ? '130' : '340'}px;
      border-bottom-right-radius: 100% ${isMobile ? '130' : '340'}px;
  `}

  .banner--badge {
    width: 240px;
    left: 24px;
  }

  ${({ theme }) => theme.media.showAt({ from: 3, to: 4 })`
    .banner--badge {
      left: 0;
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 5 })`
    .banner--badge {
      left: -140px;
    }
  `}
`;

export const BaseGradient = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    content: '';
    display: block;
`;

export const RadialGradient = styled(BaseGradient)`
  background-image: radial-gradient(circle at 30% 53%, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.04) 25%, rgba(0, 0, 0, 0.48) 59%);
`;

export const LeftGradient = styled(BaseGradient)`
  width: 35%;
  background: rgb(0, 0, 0);
  background: linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  opacity: 0.44;
  right: auto;
`;

export const Persona = styled.div`
  position: absolute;
  bottom: 0;
  left: 60px;
  img {
    display: block;
  }
  ${({ theme }) => theme.media.showAt({ at: 3 })`
    left: 180px;
  `}
  ${({ theme }) => theme.media.showAt({ at: 4 })`
    left: 220px;
  `}
  ${({ theme }) => theme.media.showAt({ at: 5 })`
  `}
`;


export const RightGradient = styled(BaseGradient)`
  width: 35%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  transform: scaleX(-1);
  opacity: .44;
`;


export const MobileBanner = styled.section`
  ${({ theme }) => `
    position: relative;
    height: 420px;
    background: url(${BASE_BG});
    opacity: 0.95;
    margin-top: -${theme.spacing(5)};
    margin-bottom: ${theme.spacing(10)};
    ::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(to top, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0) 34%);
    }

    .mobile-agent-image {
      position: absolute;
      bottom: 0;
      display: block;
      left: 50%;
      max-height: 380px;
      max-width: 100%;
      transform: translate(-50%, 0);
    }
  `}
`;

export const MobileBannerWrapper = styled.div`
  ${({ theme }) => `
    position: absolute;
    bottom: ${theme.spacing(9)};
    right: ${theme.spacing(3)};
    z-index: 1;
    display: flex;
    align-items: center;
    svg {
      margin-left: ${theme.spacing(1)};
    }
  `}
`;

export const MobileBannerBadge = styled(Text)`
  ${({ theme }) => `
    line-height: 19px;
    color: ${theme.colors.neutrals.white};
  `}
`;


export const AdvantageSection = styled(ContentBox.withComponent('section'))<{ smallMargin: boolean }>`
  ${({ theme, smallMargin }) => `
    display: flex;
    margin-top: ${theme.spacing(smallMargin ? 4 : 13)};
  `}
`;

export const WinnersSection = styled(ContentBox.withComponent('section'))`
  ${({ theme }) => `
    padding: 0 ${theme.spacing(3)};
  `}
`;

export const AgentFilterSection = styled(ContentBox.withComponent('section'))<{ smallMargin: boolean }>`
  ${({ theme, smallMargin }) => `
    display: flex;
    margin-top: ${theme.spacing(smallMargin ? 6 : 12)};
    padding: 0 ${theme.spacing(3)};
  `}
`;

export const ActionSection = styled(ContentBox)<{ zeroBorder: boolean }>`
  ${({ theme, zeroBorder }) => `
    margin-top: ${theme.spacing(12)};
    padding: 0 ${theme.spacing(3)};
    ${zeroBorder ? `
      section {
        border-radius: 0;
      }
    ` : ''}
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: 0;
  `}
`;

export const FooterSection = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.spacing(21)};
  `}
`;
